import { Component, input } from '@angular/core';
import { NxIconModule } from '@aposin/ng-aquila/icon';
import { TranslateModule } from '@ngx-translate/core';

import { FormattedPublicData } from '#models/MicroController.model';

@Component({
  selector: 'kyc-control-data',
  imports: [NxIconModule, TranslateModule],
  templateUrl: './control-data.component.html',
})
export class ControlDataComponent {
  readonly publicData = input.required<FormattedPublicData[]>();
}
